import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteMethod, getMethod, postMethod, putMethod, setAuthorizationToken } from "../../utils/apiServices";

export const getUnitFeatures = createAsyncThunk("unitFeatures/fetchUnitFeatures", async () => {
  setAuthorizationToken(true);
  const response = await getMethod(`/api/unit-features`);
  return response;
});

const initialState = {
  loading: false,
  success: false,
  error: false,
  unitFeatures: null,
};

const unitFeaturesSlice = createSlice({
  name: "unitFeatures",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getUnitFeatures.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUnitFeatures.fulfilled, (state, action) => {
        state.loading = false;
        state.unitFeatures = action.payload.data;
      })
      .addCase(getUnitFeatures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export default unitFeaturesSlice.reducer;

export const addUnitFeatures = (data, SuccessCallback, ErrorCallback) => async (dispatch) => {
  setAuthorizationToken(true);
  const response = await postMethod(`/api/admin/unit-features`, data);
  if (response?.success) SuccessCallback(response);
  else ErrorCallback(response);
};

export const updateUnitFeatures = (id, data, SuccessCallback, ErrorCallback) => async (dispatch) => {
  setAuthorizationToken(true);
  const response = await putMethod(`/api/admin/unit-features/${id}`, data);
  if (response?.success) SuccessCallback(response);
  else ErrorCallback(response);
};

export const deleteUnitFeatures = (id, SuccessCallback, ErrorCallback) => async (dispatch) => {
  setAuthorizationToken(true);
  const response = await deleteMethod(`/api/admin/unit-features/${id}`);
  if (response?.success) SuccessCallback(response);
  else ErrorCallback(response);
};
